import React from "react";

export default function ListLoader({ userName, setShowNav }) {
  return (
    <div className="">
      <div className="loadersecond"></div>{" "}
    </div>
  );
}
